import { axiosAdminApiClient, axiosApiClient } from "..";
import { handleError } from "../../utils/errors";

class PaymentsService {
  // Brza rezervacija PLAĆENE radionice bez naloga: ime, prezime, telefon, email
  // + ID termina. Javna ruta (axiosApiClient); ako je korisnik prijavljen, token
  // ide uz zahtev pa server porudžbinu veže za nalog. Vraća paymentData za
  // Raiffeisen formu (PaymentRedirect).
  initiateWorkshopReservation = async (reservationData) => {
    try {
      const response = await axiosApiClient.post(
        "/payments/raiffeisen/workshop-reservation",
        reservationData,
      );
      return response.data;
    } catch (err) {
      throw handleError(err, "Greška pri pokretanju plaćanja rezervacije");
    }
  };

  initiateRaiffeisenPayment = async (orderData) => {
    try {
      const response = await axiosAdminApiClient.post(
        "/payments/raiffeisen/initiate",
        {
          orderData: orderData,
        },
        {
          withCredentials: true,
        },
      );

      if (response.status !== 200) {
        throw new Error("Failed to initiate payment");
      }

      return response.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while initiating Raiffeisen payment",
      );
    }
  };

  // Provera stvarnog statusa porudžbine (koristi PaymentSuccess da ne veruje
  // slepo URL parametrima pre nego što isprazni korpu / prikaže uspeh).
  // Radi i bez prijave: gost posle plaćanja radionice dobija samo status +
  // termin (server ne vraća lične podatke neprijavljenom posetiocu).
  checkOrderStatus = async (orderNumber) => {
    const response = await axiosAdminApiClient.get(
      `/payments/raiffeisen/status/${orderNumber}`,
      { withCredentials: true },
    );
    return response.data;
  };
}

export default new PaymentsService();
